<template>
    <div class="notification d-flex gap-3 align-items-center"> <!--  :class="[flag, {'new-notification': newNotification && !isLms}]" -->
        
        <!-- <pre style="position:absolute;top:0;left:0;font-size:10px;width:100%;">{{ type }}</pre> -->
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
        <component 
            :is="getComponentType()"
            :data="data"
            :icon="icon"
            :category="category"
        >
        </component>

    </div>
</template>

<script>
import GenericNotification from "@/components/Notifications/NotificationsTypes/GenericNotification.vue";
import FriendRequest from "@/components/Notifications/NotificationsTypes/FriendRequest.vue";
// import MenuNotification from "@/components/Notifications/NotificationsTypes/MenuNotification.vue";
import PrivateMessage from "@/components/Notifications/NotificationsTypes/PrivateMessage.vue";
// import MenuInbox from "@/components/Notifications/MenuInbox.vue";

export default {
    name: "Notification",
    components: {
        GenericNotification,
        FriendRequest,
        // MenuNotification,
        // MenuInbox,
        PrivateMessage,
    },
    props: {
        data            : [],
        newNotification : { type: Boolean, default: false },
        isLms           : { type: Boolean, default: false },
    },
    data() {
        return {
            title           : "",
            text            : "",
            createdAt       : "",
            flag            : "",
            icon            : "",
            type            : "",
            notificationId  : 0,
            category        : "",
        }
    },
    beforeMount(){

        let root_ = this;

        console.log('DATA =>', root_.data);
        root_.type      = root_.data.type;
        root_.icon      = root_.getIcon(root_.type);
        root_.category  = root_.getCategory(root_.type);

        // root_.title     = root_.data.title ?? root_.data.object.title;
        // root_.text      = root_.data.text ?? root_.data.object.text;
        // root_.text      = root_.data.text ?? root_.data.object.text;
        // root_.flag      = root_.data.flag ?? root_.data.object.flag;
        // root_.time_ago  = root_.data.time_ago;

    },
    methods: {
        /*
            (ok) system
            (ok) friend_request
            (ok) private_message
            (ok) cart_order
            (ok) lms_finished_lesson | lms_finished_section | lms_finished_course
            (ok) package_payment
            (ok) etalent_report
            (ok) notify_points
            (ok) easter_egg
            (ok) max_points
            (ok) exchange_mascot
            (ok) vip_room_request
        */
        getIcon(type) {

            if( type === "cart_order" || type === "package_payment" ) {
                return "add_shopping_cart";
            }
            else if( type === "lms_finished_lesson" || type === "lms_finished_section" || type === "lms_finished_course" ) {
                return "local_library";
            }
            else if( type === "etalent_report" ) {
                return "summarize";
            }
            else if( type === "notify_points" || type === 'max_points' ) {
                return "timeline";
            }
            else if( type === "easter_egg" ) {
                return "redeem";
            }
            else {
                return "mail";
            }

        },
        // category é a primeira palavra que aparece na notificação (que fica de uma cor diferente do texto)
        getCategory(type) {
            let root_ = this;
            if( type === "private_message" || type === 'friend_request' ) {
                return root_.data.nickname;
            }
            else if( type === 'lms_finished_course' || type === 'lms_finished_section' || type === 'lms_finished_lesson' ) {
                return 'LMS';
            }
            else if( type == 'cart_order' ) {
                return this.$i18n.t('notification.category_cart_order');
            }
            else if( type == 'exchange_mascot' ) {
                return this.$i18n.t('notification.category_exchange_mascot');
            }
            else if( type == 'vip_room_request' ) {
                return 'VIP';
            }
            else if( type === "notify_points" || type === 'max_points' ) {
                return this.$i18n.t('notification.category_notify_points');
            }
            else if( type == 'package_payment' ) {
                return this.$i18n.t('notification.category_package_payment');
            }
            else if( type == 'etalent_report' ) {
                return 'Etalent';
            }
            else if( type == 'easter_egg' ) {
                return this.$i18n.t('notification.category_easter_egg');
            }
            else if( type == 'system' ) {
                return this.$i18n.t('notification.category_cart_system');
            }
            return ''
        },
        getComponentType() {
            // console.log('TYPE =>', this.type);
            // if(this.type === 'cart_order' || this.type === "package_payment"
            //     || this.type === "lms_finished_lesson" || this.type === "lms_finished_section" || this.type === "lms_finished_course"
            //     || this.type === 'etalent_report'
            // ){
            //     return GenericNotification;
            // }
            if(this.type === "private_message") {
                return PrivateMessage;
            }
            else if(this.type === "friend_request") {
                return FriendRequest;
            }
            // else if(this.type === "menu_notification") {
            //     return MenuNotification;
            // }
            else {
                return GenericNotification;
            }

        },
    }
}
</script>

<style scoped lang="scss">
.notification {
    border-bottom: 1px solid #E1E1E1;
    position: relative;

    .done {
        cursor: pointer;
        color: var(--buttons_color);
        font-size: 25px;
        position: relative;

        &:before {
            content: "";
            position: absolute;
            top: -10px;
            bottom: -10px;
            left: -10px;
            right: -10px;
        }

    }

    &.new-notification {
        background-color: pink !important;
    }

    &.pendent {
        background-color: #00C4FF1F;

        &:hover {
            background-color: #F9F9F9;
        }
    }

    &.viewed {
        background-color: #FFFFFF;


        &:hover {
            background-color: #F9F9F9;
        }
    }

    &:hover {
        background-color: #F9F9F9;
    }

    // &.is-lms {
    //     &:after {
    //         display: none !important;
    //     }
    // }

}
</style>